"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickService = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("../types");
var event_1 = require("../utils/event");
var ClickService = /** @class */ (function () {
    function ClickService() {
    }
    ClickService.prototype.handle = function (data, event) {
        var _this = this;
        this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // 由于 clickOrder 的增加是异步的，快速点击会导致都会用到最后一个值，因此这里先暂停执行
                    // this.applicationExecutor.setReady(false);
                    return [4 /*yield*/, this.eventOrderBucket.increaseClickOrder()];
                    case 1:
                        // 由于 clickOrder 的增加是异步的，快速点击会导致都会用到最后一个值，因此这里先暂停执行
                        // this.applicationExecutor.setReady(false);
                        _b.sent();
                        _a = data;
                        return [4 /*yield*/, this.eventOrderBucket.getClickOrder()];
                    case 2:
                        _a.click_order = _b.sent();
                        // clickOrder 增加完成后，恢复执行
                        // this.applicationExecutor.setReady(true);
                        this.sendToSaService.dispatch({
                            list: [
                                __assign({ 
                                    // 默认 WebClick 事件，有可能是 PopClick
                                    eventType: (0, event_1.resolveEventName)(data, types_1.EventType.Click) }, data),
                            ],
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ClickService.prototype.click = function (data, event) {
        if (!data) {
            return;
        }
        this.handle(data, event);
    };
    ClickService.prototype.update = function (_a) {
        var data = _a.data, event = _a.event;
        this.handle(data, event);
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IApplicationExecutor),
        __metadata("design:type", Object)
    ], ClickService.prototype, "applicationExecutor", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventOrderBucket),
        (0, inversify_1.named)(types_1.TAG.EventOrderBucket),
        __metadata("design:type", Object)
    ], ClickService.prototype, "eventOrderBucket", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.ISendToSaService),
        __metadata("design:type", Object)
    ], ClickService.prototype, "sendToSaService", void 0);
    ClickService = __decorate([
        (0, inversify_1.injectable)()
    ], ClickService);
    return ClickService;
}());
exports.ClickService = ClickService;
